import { Component, inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HdmuiDialogOptions } from '@heidelberg/hdmui-angular';


@Component({
  selector: 'app-about-dialog',
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.css'],
  standalone: false
})
export class AboutDialogComponent {
  dialogRef = inject<MatDialogRef<AboutDialogComponent>>(MatDialogRef);
  data = inject<AboutData>(MAT_DIALOG_DATA);

  option = HdmuiDialogOptions.OPTION_OK;

  onCancel(): void {
    this.dialogRef.close();
  }

  onOk(): void {
    this.dialogRef.close(true);
  }

}

export interface AboutData {
  appName: string;
  text: string;
  copyright: string;
  appIcon: string;
}


